import React, { useEffect, useState } from 'react';
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import Styles from "./styles.module.scss";
import TotalInfoCards from "./totalInfoCards";
import ActivePositions from "./ActivePositions";
import PositionStatus from "./positionStatus";
import * as CONSTANTS from '../../utils/CONSTANTS'
import { makeSideBarActive } from '../../utils/EllowUtils';
import ComingSoon from '../../components/comingSoon'
import SubmittedCandidates from './submittedCandidates';
import { getCandidates, getChartData, getPositions, getPositionsCount } from './services';
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify"
import mixpanelData, { viewedpageMixpanel } from '../../utils/mixpanel';

function Dashboard() {

  let login_id = localStorage.getItem('loginId')
  let navigate = useNavigate();

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 0)
  const breadCrums = ['Dashboard']

  const [data, setData] = useState<any>()
  const [countData, setCountData] = useState<any>()
  const [fullName, setFullName] = useState<any>()
  const [chartData, setChartData] = useState<any>()
  const [submittedCandidatesData, setSubmittedCandidatesData] = useState<any>()

  useEffect(() => {
    displayUserDetails();
    getAllPositions("active", 1, 5, "",);
    getPositionCount()
    getDashboardChartdata()
    getdashboardResources()
  }, [])

  useEffect(() => {
    viewedpageMixpanel();
  }, [])
 


  async function displayUserDetails() { 
    Auth.userAttributes(await getCurrentUser())
    .then(result => {
       let emailindex = result.findIndex((item) => item.Name === 'email');
       let loginidindex = result.findIndex((item) => item.Name === 'sub');
       let given_name_index = result.findIndex((item) => item.Name === 'given_name');
       let family_name_index = result.findIndex((item) => item.Name === 'family_name');
       localStorage.setItem('Name', result[given_name_index].Value + ' ' + result[family_name_index].Value)
       setFullName(result[given_name_index].Value + ' ' + result[family_name_index].Value);
      //  localStorage.setItem('Role', 'CS-RECRUITER')
       localStorage.setItem('loginId', result[loginidindex].Value)
      localStorage.setItem('Email', result[emailindex].Value) 
      mixpanelData('TG - Login Successfully', {
        'source': 'Recruiter successfully sign in with google',
        'Recruiter name': result[given_name_index].Value + ' ' + result[family_name_index].Value,
        'Recruiter email': result[emailindex].Value,
        'distinct_id': result[emailindex].Value
      })
       })
  }
  
  const getToken = async () => {
    try {
      const session = await Auth.currentSession();
      const accessToken = session.getIdToken().getJwtToken();   
      const refreshToken = session.getRefreshToken().getToken();
      localStorage.setItem('Token', accessToken)
      localStorage.setItem('refreshToken', refreshToken)
      return accessToken;
    } catch (error) {
      console.log('Error getting access token:', error);
      return null;
    }
  };

      async function getCurrentUser() {
        try {
          var currentUser = await Auth.currentAuthenticatedUser()
          // setGoogleId(currentUser.username)
        //  googleId = currentUser.username
          getToken();
    //    localStorage.setItem('Token', getToken)
        
          return currentUser;
        }
        catch (err: any) {
          navigate(`/login`, {
            state: {
              error: err,
            }
        }
        );
        }
      } 

  const getdashboardResources = (filters?: any) => {

    let body = {}
    if (filters) {
      body = {
        filters: {
          position_status: ['Submitted to Hirer'],
          loginId: localStorage.getItem('loginId'),
          dateWithin: filters.dateWithin
        }
      }
       
    } else {
      body = {
        filters: {
          position_status: ['Submitted to Hirer'],
          loginId: localStorage.getItem('loginId'),
        }
      }
    }
  
    getCandidates('allResource', 100, 1, '', body).then((response) => {
      if (response && response.status === 1) {
        setSubmittedCandidatesData(response.data)
      }
    })
   }



  const getAllPositions = ( positionType: string,
    pageNumber: number,
    pageSize: number,
    searchValue: string,
    filters?: any) => {

    let data = {}
    if (filters) {
      data = {
        positionType: positionType,
        login_id: localStorage.getItem('loginId'),
        filters: filters
      }
    }
    else {
      data = {
        positionType: positionType,
        login_id: localStorage.getItem('loginId'),
      }
    }
  
    
    getPositions(searchValue, pageNumber, pageSize, data).then((resp) => {
      if (resp && resp.status === 1) {
        setData(resp.data)
      }
    })
  }
  
  const getDashboardChartdata = () => {

    getChartData(login_id).then((response) => {
      if (response && response.status === 1) {        
       setChartData(response.data[0])
     }
   })
 }


  const getPositionCount = (filters?: any) => {

    let body = {
      filters: filters ? filters : {}
    }
    getPositionsCount(login_id, body).then((response) => {
      if (response && response.status === 1) {
        setCountData(response.data[0])
      }
    })
  }

  const filterChange = (data: any) => {
    if (data) {
      getAllPositions("active", 1, 5, "", { dateWithin: { from: data.from, to: data.to } });
      getdashboardResources({ dateWithin: { from: data.from, to: data.to } })
      getPositionCount({"dateWithin": {
        "from": data.from,
        "to": data.to
    }})
    } else {
      getAllPositions("active", 1, 5, "",);
      getPositionCount()
      getDashboardChartdata()
      getdashboardResources()
    }

  }

  return (
    // <ComingSoon/>
    //  <ComingSoon/>
    <section className="dashboardWrapper">
      <SideMenu menu={menu} userName={fullName}/>
      <div className="dashboardContent">
        <DashboardHeader title={breadCrums} searchChange={undefined} dashboard={true} applyDashboardFilter={filterChange} />
        <TotalInfoCards countData={countData} chartData={chartData}/>
        <SubmittedCandidates data={submittedCandidatesData} />
        {/* <ActivePositions/> */}
        <PositionStatus tableData={data} chartData={chartData} />
      </div>
    </section>
  )
}

export default Dashboard